<style lang="scss" scoped>

.fade-enter-active,
.fade-leave-active {
    transition: all 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    transform: translateY(-20%);
    opacity: 0;
}

</style>

<template>
    <transition name="fade">
        <div v-show="isVisible" class="alert" :class="'alert-'+type"  role="alert">
            <h4 class="alert-title">
                <slot name="title">
                </slot>                            
            </h4>
            <div class="text-muted"><slot></slot></div>
        </div>
    </transition>
</template>
<script>

export default {
    name: 'Alert',
    props: {
        show: {
            type: Boolean,
            default: true
        },
        timeout: {
            type: Number,
            default: 0
        },
        type: {
            type: String,
            default: 'info'
        }
    },
    data: function () {
        return {
            isVisible: false,
            timeoutId: null
        }
    },
    mounted: function () {
        if (this.show == true) {
            this.showAlert();
        }
    },
    methods: {
        showAlert: function () {
            let self = this;
            
            if (self.isVisible === true) {
                return;
            }
            this.isVisible = true;
            
            if (self.timeoutId) {
                clearTimeout(self.timeoutId);
            }
            
            if (self.timeout > 0) {
                self.timeoutId = setTimeout(function () {
                    self.isVisible = false; 
                }, self.timeout);
            }
        },
        hideAlert: function () {
            let self = this;
            
            if (self.isVisible === false) {
                return;
            }
            
            if (self.timeoutId) {
                clearTimeout(self.timeoutId);
            }

            self.timeoutId = setTimeout(function () {
                self.isVisible = false;
            }, 100);
        } 
    },
    watch: {
        show: function (new_value, old_value) {
            if (new_value == true && old_value == false) {
                this.showAlert();
            } else if (new_value == false && old_value == true) {
                this.hideAlert();                       
            }
        }
    }
}

</script>